import {requests} from "../../helpers/api.services";
import {SECTION_SETTINGS_URL} from "../../helpers/api.routes";
import {ISectionSettings} from "./interface";

export const AdminSectionSettingsService = {
    get: () => requests.get(SECTION_SETTINGS_URL),
    create: (params: ISectionSettings) => requests.post(SECTION_SETTINGS_URL, params)
}